import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { StoryElement, SocialShare } from "@quintype/components";
import { WebEngage, ComScore, DeepBI, Chartbeat, GA, ContentInsights } from "../../../integrations";
import BreadCrumb from "../story/story-templates/shared/breadcrumbs";
import Navbar from "../../atoms/secondary-menu";
import { DfpAd } from "../../atoms/dfp-ad";
import Icon, { ZodiacIcon } from "../../atoms/icon";
import { PAGE_TYPE } from "../../../constants";
import styles from "./styles.m.css";
import Media from "react-media";
import { SocialShareTemplate } from "../story/story-templates/shared/social-share";
import { getRasipalanPath } from "../../utils/urls";

const ALMANAC_HEADLINE = "பஞ்சாங்கம்";

export class RasipalanLandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedZodiac: "aries",
      isDropdownOpen: false
    };
    this.selectZodiac = this.selectZodiac.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  selectZodiac(type) {
    this.setState({ selectedZodiac: type, isDropdownOpen: false });
  }

  toggleDropdown() {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
  }

  componentDidMount() {
    WebEngage.registerPageView();
    ComScore.registerPageView();
    DeepBI.loadScript();
    Chartbeat.registerPageView(this.props.data.story);
    GA.registerPageView(PAGE_TYPE.RASIPALAN_PAGE, { story: get(this.props, ["data", "story"], {}) });
    ContentInsights.registerPageView(this.props.config.contentInsightsId, get(this.props, ["data", "story"], {}));
  }

  render() {
    const data = get(this.props, ["data"], {});
    const dateInTamil = getDateInTamil(get(data, ["story", "last-published-at"], ""));
    const summary = get(data, ["story", "cards", 0], {});
    const headline = get(data, ["story", "headline"], "Today's Rasi Palan");
    const zodiacCards = get(data, ["story", "cards"], []).slice(1);
    const subMenu = get(data, ["menuData"], {});
    const almanac = get(data, ["almanac"], []) || [];
    const almanacTRs = almanac.map(({ key, displayName, value }) => (
      <tr key={key} className={styles.almanac__entity}>
        <th>{displayName}</th>
        <td>{value}</td>
      </tr>
    ));

    const config = get(this.props, ["config"], {});

    return (
      <div className={`${styles["page"]} main-page`}>
        <DfpAd className="hidden-mobile ad-tower-left" adtype="Tower_Left" placement="all" />
        <div>
          {subMenu ? (
            <Navbar
              menuGroup={subMenu}
              slug={"spiritual"}
              className={`${styles["submenu"]} ${"container-full-mobile"}`}
              communityColor={subMenu.bgColor}
            />
          ) : null}
          <div className="container">
            <BreadCrumb config={config} story={data.story} />
            <h1 className={styles.headline}>{headline}</h1>
            <div className={styles["rasipalan__base"]}>
              <div className={`row ${styles.rasipalan__row}`}>
                <div className={styles.rasipalan__date}>
                  {dateInTamil && (
                    <React.Fragment>
                      <span className={styles.rasipalan__date_dd}>{dateInTamil.date}</span>
                      <span className={styles.rasipalan__date_month}>{dateInTamil.month}</span>
                      <span className={styles.rasipalan__date_yyyy}>{dateInTamil.year}</span>
                    </React.Fragment>
                  )}
                </div>
                <div className={styles.rasipalan__summary}>
                  {summary["story-elements"].map(element => (
                    <StoryElement card={summary} element={element} key={element.id} />
                  ))}
                </div>
                <aside className={styles.rasipalan__sidebar}>
                  <button
                    title="toggle dropdown"
                    aria-label="toggle dropdown"
                    role="button"
                    className={`hidden-desktop ${styles["dropdown-button"]}`}
                    onClick={this.toggleDropdown}
                  >
                    <div className={`${styles.sidebar__dropdown_heading_wrapper}`}>
                      <h3 className={styles.sidebar__dropdown_heading}>
                        {data.zodiacs.filter(zodiac => zodiac.type === this.state.selectedZodiac)[0].display_name}
                      </h3>
                      <Icon
                        type={this.state.isDropdownOpen ? "angle-up" : "angle-down"}
                        className={styles.sidebar__expand_collapse}
                      />
                    </div>
                  </button>
                  <SideBar
                    zodiacs={data.zodiacs}
                    selectedZodiac={this.state.selectedZodiac}
                    onSelectZodiac={this.selectZodiac}
                    className={!this.state.isDropdownOpen ? styles.sidebar__collapse : styles.sidebar__expand}
                  />
                </aside>
                <div className={styles.rasipalan__content}>
                  <div className={styles.rasipalan__zodiac_active}>
                    <ZodiacIcon
                      type={this.state.selectedZodiac}
                      className={styles.rasipalan__big_icon}
                      hoverDefault={true}
                    />
                    {data.zodiacs.filter(zodiac => zodiac.type === this.state.selectedZodiac).map(zodiac => (
                      <h2 className={styles.zodiac__display_name} key={zodiac.type}>
                        {zodiac.display_name}
                      </h2>
                    ))}
                    <Icon type={"share-alt"} className={styles.rasipalan__share_icon} />
                  </div>
                  {zodiacCards.map((card, index) => (
                    <ZodiacCard
                      key={card.id}
                      className={`${data.zodiacs[index].type === this.state.selectedZodiac ? "" : "hidden"} ${
                        styles["rasipalan_zodiac-card"]
                      }`}
                      card={card}
                      story={data.story}
                    />
                  ))}
                </div>
                <Media query="(min-width: 1024px)">
                  {matches =>
                    matches ? (
                      <SocialShare
                        template={SocialShareTemplate}
                        url={getRasipalanPath()}
                        title={data.story.headline}
                      />
                    ) : null
                  }
                </Media>
                <aside className={styles.rasipalan__aside}>
                  <DfpAd className={styles.rasipalan__ad} adtype="Half_Page" placement="rasipalan" />
                  {almanacTRs.length > 0 && (
                    <div className={styles.rasipalan__almanac}>
                      <h2 className={styles.almanac__headline}>{ALMANAC_HEADLINE}</h2>
                      <table className={styles.almanac__table}>
                        <tbody>{almanacTRs}</tbody>
                      </table>
                    </div>
                  )}
                </aside>
              </div>
              <DfpAd adtype="Leaderboard" placement="rasipalan" />
            </div>
          </div>
        </div>
        <DfpAd className="hidden-mobile ad-tower-right" adtype="Tower_Right" placement="all" />
      </div>
    );
  }
}

const tamilMonthMap = {
  1: "ஜனவரி",
  2: "பிப்ரவரி",
  3: "மார்ச்",
  4: "ஏப்ரல்",
  5: "மே",
  6: "ஜூன்",
  7: "ஜூலை",
  8: "ஆகஸ்ட்",
  9: "செப்டம்பர்",
  10: "அக்டோபர்",
  11: "நவம்பர்",
  12: "டிசம்பர்"
};

const getDateInTamil = timeInMillis => {
  if (!timeInMillis) {
    return null;
  }
  const dateObj = new Date(timeInMillis);
  const dateUTC = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000);
  const dateIST = new Date(dateUTC.getTime() + 19800000);

  return { date: dateIST.getDate(), month: tamilMonthMap[dateIST.getMonth() + 1], year: dateIST.getFullYear() };
};

const SideBar = ({ zodiacs, onSelectZodiac, selectedZodiac, className }) => {
  const signs = zodiacs.map(zodiac => (
    <div key={zodiac.type} className={`${styles["sidebar__zodiac"]}`} onClick={() => onSelectZodiac(zodiac.type)}>
      <ZodiacIcon
        type={zodiac.type}
        className={styles["sidebar__zodiac-icon"]}
        hoverDefault={selectedZodiac === zodiac.type}
      />
      <h3 className={styles["sidebar__zodiac-name"]}>{zodiac.display_name}</h3>
    </div>
  ));
  return <div className={`${className} ${styles["sidebar__base"]}`}>{signs}</div>;
};

const ZodiacCard = ({ card, className }) => {
  let elements = card["story-elements"].map(element => <StoryElement card={card} element={element} key={element.id} />);
  return <section className={className}>{elements}</section>;
};

ZodiacCard.propTypes = {
  card: PropTypes.any,
  className: PropTypes.string
};

SideBar.propTypes = {
  zodiacs: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      display_name: PropTypes.string,
      dates: PropTypes.string
    })
  ),
  selectedZodiac: PropTypes.string,
  onSelectZodiac: PropTypes.func,
  className: PropTypes.string
};

RasipalanLandingPage.propTypes = {
  data: PropTypes.shape({
    story: PropTypes.any,
    zodiacs: SideBar.propTypes.zodiacs
  }),
  config: PropTypes.shape({
    contentInsightsId: PropTypes.string
  })
};

export default RasipalanLandingPage;
